import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input } from '@angular/core';

import type { UnwrapInput } from '@core/common-legacy';
import { injectUntilDestroyed } from '@core/utils-legacy';

import { ButtonComponent } from '../../../../common/button/components/button/button.component';
import { ButtonDropdownIndicatorDirective } from '../../../../common/button/directives/button-dropdown/button-dropdown-indicator.directive';
import { IconComponent } from '../../../../common/icon/icon.component';
import type { IconName } from '../../../../common/icon/icons.type';
import { SelectController } from '../../services/select-controller.service';

@Component({
  selector: 'rt-select-trigger-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, ButtonDropdownIndicatorDirective, IconComponent],
  template: `
    <rt-button
      [variant]="buttonVariant()"
      [dropdownOpened]="selectCtrl.isOpen()"
      [dropdownVisible]="dropdownIconVisible()"
      [disabled]="disabled()"
      (click)="selectCtrl.toggle(true)"
    >
      @if (icon(); as iconName) {
        <rt-icon [name]="iconName" />
      }
      {{ selectCtrl.itemSelector.selected()?.label || label() }}
    </rt-button>
  `,
})
export class Select2TriggerButtonComponent {
  public buttonVariant = input<UnwrapInput<ButtonComponent['variant']>>('plain');
  public label = input<string | null>(null);
  public icon = input<IconName | null>(null);
  public dropdownIconVisible = input(true);
  public disabled = input(false);

  private untilDestroyed = injectUntilDestroyed();

  constructor(
    public selectCtrl: SelectController,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.selectCtrl.detectChanges$
      .pipe(this.untilDestroyed)
      .subscribe(() => this.cdRef.detectChanges());
  }
}
